import {Alert, Anchor, Button, Card, Stack, Text, Title} from "@mantine/core";
import {useCallback, useMemo, useState} from "react";
import {useAuth} from "../context/AuthProvider";
import {HandleTypeahead} from "./HandleTypeahead";

const pdsDomain = [
  "bsky.social",
  "npmx.social",
  "tngl.sh",
  "selfhosted.social",
  "myatproto.social",
  "blacksky.app",
  "cryptoanarchy.network",
  "margin.cafe",
];

export function LoginForm() {
  const [{isLoading, error}, actions] = useAuth();
  const [handle, setHandle] = useState("");

  const placeholder = useMemo(() => {
    return `frank.${pdsDomain[Math.floor(Math.random() * pdsDomain.length)]}`;
  }, []);

  const handleSubmit = useCallback(() => {
    actions.login(handle);
  }, [actions, handle]);

  return (
    <Card
      withBorder
      radius="lg"
      p="xl"
      maw={500}
      mx="auto"
      className="glass-card"
      bg="transparent"
    >
      <Title order={2} size="h3" ta="center" mb="xl">
        Welcome back
      </Title>
      <form onSubmit={e => e.preventDefault()}>
        <Stack gap="lg">
          <HandleTypeahead
            value={handle}
            onChange={setHandle}
            onSubmit={handleSubmit}
            disabled={isLoading}
            placeholder={placeholder}
          />

          {error && (
            <Alert color="red" radius="md">
              {error.message}
            </Alert>
          )}

          <Button
            type="submit"
            loading={isLoading}
            fullWidth
            size="md"
            color="violet"
            variant="filled"
          >
            Get Started
          </Button>
        </Stack>
      </form>

      <Text ta="center" size="sm" mt="xl" c="dimmed">
        Don&apos;t have a Bluesky account?{" "}
        <Anchor
          href="https://bsky.app"
          target="_blank"
          rel="noopener noreferrer"
          fw={500}
          underline="never"
        >
          Create one here
        </Anchor>
      </Text>
    </Card>
  );
}
